import ReactOnRails from 'react-on-rails';

import Header from '../components/Header';
import NextUpImage from '../components/NextUpImage';
import Favorite from '../components/Favorite';
import FavoriteStore from '../components/Favorite/store';
import PhotoDetailImage from '../components/PhotoDetailImage';
import FavoriteToast from '../components/FavoriteToast';
import StickyHead from '../components/StickyHead';
import LinkAgent from '../components/LinkAgent';
import Footer from '../components/Footer';
import IconAgent from '../components/IconAgent';
import SocialSharingWidgets from '../components/SocialSharingWidgets';
import Spinner from '../components/Spinner';
import VendorItem from '../components/VendorItem';
import LazyloadImage from '../components/LazyloadImage';

ReactOnRails.register({
  Header,
  StickyHead,
  IconAgent,
  Favorite,
  FavoriteStore,
  SocialSharingWidgets,
  PhotoDetailImage,
  VendorItem,
  NextUpImage,
  LazyloadImage,
  LinkAgent,
  FavoriteToast,
  Footer,
  Spinner
});
